// extracted by mini-css-extract-plugin
export var icon = "_95-3";
export var subtitle = "_95-2";
export var title = "_95-1";
export var value = "_95-0";